var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compensation-step"},[_c('span',{staticClass:"compensation-step__order-number"},[_vm._v(_vm._s(_vm.orderNumber))]),_c('p',{staticClass:"compensation-step__description",domProps:{"innerHTML":_vm._s(_vm.textHtml)}}),_c('span',{staticClass:"compensation-step__step-arrow",class:{
            'compensation-step__step-arrow--hidden': _vm.hideStepArrow
        }},[_c('SvgIcon',{staticClass:"compensation-step__step-arrow-icon",attrs:{"name":"arrow-bottom"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }